import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import RegisterForm from 'src/components/RegisterPage/registerForm'

const RegisterPage = ({ onRegistered }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const userId = params.get('userId');

  return (
    <div>
 
      <RegisterForm userId={userId} onRegistered={onRegistered} />
    </div>
  );
};

RegisterPage.propTypes = {
  onRegistered: PropTypes.func.isRequired,
};

export default RegisterPage;
